
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.164 7.57V6.531h3.953l.938-2.203H.165V3.29H5.5L6.57.781h.946L6.446 3.29h3.343v1.04H6L5.062 6.53H9.79v1.04H4.617l-1.172 2.75H2.5l1.172-2.75H.164z","fill":"currentColor"}})])
          )
        }
      }
    